import { jsx } from "panel";
import { SelectTheme } from "common/components/select/constants";
import { SelectEl } from "common/components/select";
import { SpinnerEl } from "common/components/spinner";
export function template() {
  const { fetchedDataGroups, selected } = this.state;
  return /* @__PURE__ */ jsx("div", {
    sel: ".mp-data-group-selector-container",
    class: {
      "mp-data-group-selector-theme-builder": this.attr(`theme`) === `builder`,
      "mp-data-group-selector-theme-default": !this.attr(`theme`),
      "mp-data-group-selector-is-loaded": fetchedDataGroups
    }
  }, /* @__PURE__ */ jsx("div", {
    sel: ".mp-data-group-selector-label"
  }, this.attr(`label`)), /* @__PURE__ */ jsx("div", {
    sel: ".mp-data-group-selector-select-wrapper"
  }, !fetchedDataGroups ? /* @__PURE__ */ jsx(SpinnerEl, null) : /* @__PURE__ */ jsx(SelectEl, {
    attrs: {
      theme: this.attr(`theme`) === `builder` ? SelectTheme.Builder : SelectTheme.BuilderLight,
      sections: this.helpers.getDataGroupsList(),
      "selected-option": selected.displayName,
      "menu-width": 270,
      tooltip: {
        text: selected.displayName === `User` ? `Analyze uniques as individual users
[Learn More](https://help.mixpanel.com/hc/en-us/articles/360025333632)` : `Analyze uniques as a group 
[Learn More](https://help.mixpanel.com/hc/en-us/articles/360025333632)`,
        placement: `right`
      },
      "always-show-caret": true,
      icon: { rightIcon: `caret-down` }
    },
    on: { change: this.helpers.clickDataGroupOption }
  })), this.attr(`label-right`) ? /* @__PURE__ */ jsx("div", {
    sel: ".mp-data-group-selector-label-right"
  }, this.attr(`label-right`)) : null);
}
